export function normalizeGates(value) {
  if (Array.isArray(value)) {
    return value
      .map((item) => String(item || '').trim())
      .filter(Boolean)
      .map((item) => item.replace(/\s+/g, ' '))
  }

  if (typeof value !== 'string') return []

  return value
    .split(/[\n,;]+/)
    .map((item) => item.trim())
    .filter(Boolean)
    .map((item) => item.replace(/\s+/g, ' '))
}
